import React from "react";

import { CCol, CProgress, CRow } from "@coreui/react";
import { FaRegPlayCircle } from "react-icons/fa";
import { RiGitBranchLine } from "react-icons/ri";
import "./styles.css";

export const TrailDashBoardItem = props => (
  <CRow className="trail-item-content d-flex align-items-center my-3">
    <CCol md="2" className="trail-item-image-content">
      <RiGitBranchLine className="trail-item-image" />
    </CCol>
    <CCol
      sm="12"
      md={`${props.admin ? "10" : "6"}`}
      className="trail-item-main-content justify-items-start"
    >
      <h1 className="trail-item-tile">{props.title}</h1>
      <div className="d-flex w-100 align-items-center">
        <CProgress value={props.progress} className="trail-item-progressbar" />
        <p className="my-0 ml-2 text-bold">{`${props.progress}%`}</p>
      </div>
      <span className="trail-item-progressbar-description mb-2">
        Progresso geral
      </span>
    </CCol>
    <CCol
      sm="12"
      md="4"
      className={`align-items-center justify-content-center ${
        props.admin ? "d-none" : "d-flex"
      }`}
    >
      <div className="trail-item-play-container">
        <FaRegPlayCircle size={30} className="mr-3" />
        Continuar
      </div>
    </CCol>
  </CRow>
);
